import React from "react";
import {
  FileText,
  BarChart3,
  Scale,
  Briefcase,
  PieChart,
  ShieldAlert,
  FileSearch,
  Calculator,
  TrendingUp,
  GraduationCap,
  Landmark,
  Building2,
} from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: <FileSearch className="w-8 h-8 text-white" />,
      title: "Audit",
      description:
        "Independent and objective examination of financial statements to ensure accuracy, reliability, and full compliance with applicable accounting and regulatory standards.",
    },
    {
      icon: <Calculator className="w-8 h-8 text-white" />,
      title: "Accounting and Bookkeeping",
      description:
        "Comprehensive accounting and bookkeeping services that ensure accurate financial records, timely reporting, and a strong foundation for sound business decisions.",
    },
    {
      icon: <Calculator className="w-8 h-8 text-white" />,
      title: "Tax and Social Security",
      description:
        "End-to-end tax and social security services, including compliance, planning, and advisory, designed to optimize obligations while meeting all legal requirements.",
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-white" />,
      title: "Financial Advisory & Consulting",
      description:
        "Expert financial advisory and consulting services focused on enhancing performance, managing risk, and supporting strategic growth and long-term value creation.",
    },
    // {
    //   icon: <GraduationCap className="w-8 h-8 text-white" />,
    //   title: "Training & Development",
    //   description:
    //     "Practical accounting and ERP training programs to strengthen financial and operational capabilities.",
    // },
    // {
    //   icon: <Landmark className="w-8 h-8 text-white" />,
    //   title: "Government Services",
    //   description:
    //     "End-to-end handling of government transactions, regulatory filings, and official approvals.",
    // },
    // {
    //   icon: <Building2 className="w-8 h-8 text-white" />,
    //   title: "Real Estate Services",
    //   description:
    //     "Property brokerage, valuation, and real estate advisory for informed investment decisions.",
    // },
  ];

  return (
    <section
      id="services"
      className="py-12 md:py-20 bg-primary text-white min-h-[600px] md:min-h-[700px]"
    >
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 md:mb-16">
          <div className="md:w-2/3">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Our Expertise
            </h2>
            <p className="text-gray-300 max-w-xl">
              From statutory audits to strategic advisory, we offer a full suite
              of financial services tailored to your industry.
            </p>
          </div>
          {/* <div className="mt-6 md:mt-0">
            <button className="text-secondary font-semibold hover:text-white transition-colors flex items-center gap-2">
              View All Services &rarr;
            </button>
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 rounded-2xl bg-slate-800/50 border border-slate-700 hover:border-secondary transition-all hover:bg-slate-800 cursor-pointer h-full min-h-[200px] flex flex-col"
            >
              <div className="mb-6 bg-white/10 w-14 h-14 rounded-lg flex items-center justify-center group-hover:bg-secondary transition-colors">
                {React.cloneElement(service.icon, {
                  className:
                    "w-7 h-7 text-white group-hover:text-white transition-colors",
                })}
              </div>
              <h3 className="text-xl font-bold mb-3">{service.title}</h3>
              <p className="text-slate-400 leading-relaxed text-sm group-hover:text-slate-300">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
